import { Checkbox, FormControlLabel, Grid, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PolicyRenewalActionWarningsComponent from './PolicyRenewalActionWarningsComponent';
import { usePolicyRenewalUtils } from '../../utils';
import { useAuthorization } from 'hooks';
import Close from '@mui/icons-material/Close';
import InsuranceDataContext from 'features/insuranceDocument/stepper/insuranceDataContext';
import AuthorizationCodes from 'features/common/constants/authorizationCodes';

const PolicyRenewalListHeaderComponent = ({ listIds }) => {
  const { documentTypeId, documentStateId } = useContext(InsuranceDataContext);
  const hasRightToEditRenewal = useAuthorization(AuthorizationCodes.hasRightToEditRenewal, documentTypeId, documentStateId);
  const { t } = useTranslation();
  const { retrieveAvailableItems, retrieveSelectionSummary, replaceAvailableItems, deselectItems, watchSelections } =
    usePolicyRenewalUtils();

  const [pageSelected, setPageSelected] = useState(false);
  const [selectionCount, setSelectionCount] = useState(0);
  const [warningsSummary, setWarningsSummary] = useState({});

  // #region Selection

  useEffect(() => {
    const selectionSubscription = watchSelections(selections => {
      const summary = retrieveSelectionSummary(selections);
      setWarningsSummary(summary?.warnings || {});

      setSelectionCount(selections.length);
      setPageSelected(listIds.every(id => selections.some(x => x.renewalDocumentId === id)));
    });

    return () => {
      selectionSubscription.unsubscribe();
    };
  }, [listIds, watchSelections, retrieveSelectionSummary]);

  const handleSelectPage = useCallback(() => {
    let items = retrieveAvailableItems();

    items = items.map(x => (listIds.includes(x.renewalDocumentId) ? { ...x, selected: !pageSelected } : x));

    replaceAvailableItems(items);
  }, [listIds, pageSelected, retrieveAvailableItems, replaceAvailableItems]);

  // #endregion

  return (
    <>
      <PolicyRenewalActionWarningsComponent warningsSummary={warningsSummary} />
      <Grid container alignItems='center' my={1} mx={2}>
        <Grid>
          <FormControlLabel
            control={
              <Checkbox id={`renewal_page_selected`} checked={pageSelected} onChange={handleSelectPage} disabled={!hasRightToEditRenewal} />
            }
            label={`${t('SelectAllOnPage')} (${selectionCount} ${t('Selected').toLowerCase()})`}
          />
          <FormControlLabel
            control={
              <IconButton size='small' color='error' onClick={deselectItems} disabled={selectionCount <= 0}>
                <Close />
              </IconButton>
            }
            label={t('DeselectAll')}
          />
        </Grid>
      </Grid>
    </>
  );
};

PolicyRenewalListHeaderComponent.propTypes = {
  listIds: PropTypes.array
};

export default PolicyRenewalListHeaderComponent;
